import { API_URLS } from '../../../common/constants/routes-config';
import { Helper } from '@vfde-fe/ngx-lib/services/helper-utils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormSubmitPayload } from 'src/app/common/models/form-submit.model';
import { prepareUrlObject } from '@vfde-fe/ngx-lib/utils';
import { TranslateService } from '@ngx-translate/core';
import { FILE_FIELD_KEY } from 'src/app/common/constants/Defines';
/** FormSubmissionService */
@Injectable({
  providedIn: 'root',
})
export class FormSubmissionService {
  /**
   * @param helper: Helper
   */
  public constructor (public helper: Helper, public httpClient: HttpClient, private translateService: TranslateService) {}
  /** submit
   * @method submit to submit the form
   */
  public submit (formId: number, formControls: { [key: string]: AbstractControl<any, any> }, xCaptchaHash: string) {
    const formSubmitPayload: FormSubmitPayload = {
      field: {},
    };
    for (const i in formControls) {
      if (i === FILE_FIELD_KEY) {
        formSubmitPayload.file = formControls[i].value || [];
      } else if (i != FILE_FIELD_KEY && formControls[i].value) {
        formSubmitPayload.field[i] = formControls[i].value;
      }
    }
    if (Object.getOwnPropertyNames(formSubmitPayload.field).length !== 0) {
      const captchaAnswer = formSubmitPayload.field['captcha'];
      const httpHeaders = new HttpHeaders({'X-Captcha-Hash': xCaptchaHash, 'X-Captcha-Answer': captchaAnswer,'version': this.checkVersion(formId)});
      const dxlUrlObject = this.helper.prepareURLForDXL(httpHeaders, API_URLS.FORM_DETAILS.FORM_SUBMIT);
      const urlObject = prepareUrlObject(dxlUrlObject, {id: +formId});
      const requestOptions = { headers: httpHeaders };

      return this.httpClient.post(urlObject, formSubmitPayload, requestOptions).pipe(
        map((response: any) => response),
      );
    }
  }
   /** checkVersion
   * @method checkVersion to check version type
   */
  public checkVersion (formId: number): string {

     return formId == this.translateService.instant('FromCenterModule.formSubmit.formId') ? 'v1' : 'v2';
  }
}
